module.exports = __webpack_public_path__ + "static/headshot-ben-hughes-2x.e771b40e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-ben-hughes-2x.jpg
// module id = 117
// module chunks = 35783957827783 152909308826437